import api from './axiosInstance';

export const orderApi = {
  list: (params = {}) => api.get('/orders', {params}),
  getById: id => api.get(`/orders/${id}`),
  create: data => api.post('/orders', data),
  update: (id, data) => api.put(`/orders/${id}`, data),
  delete: id => api.delete(`/orders/${id}`),
  updateStatus: (id, data) => api.put(`/orders/${id}/status`, data),
  addLine: (orderId, data) => api.post(`/orders/${orderId}/lines`, data),
  updateLine: (orderId, lineId, data) =>
    api.put(`/orders/${orderId}/lines/${lineId}`, data),
  deleteLine: (orderId, lineId) =>
    api.delete(`/orders/${orderId}/lines/${lineId}`),
  updateLineStatus: (orderId, lineId, data) =>
    api.put(`/orders/${orderId}/lines/${lineId}/status`, data),
  assignWorkerToLine: (orderId, lineId, data) =>
    api.put(`/orders/${orderId}/lines/${lineId}/assign`, data),
  updateInstanceStatus: (orderId, instanceId, data) =>
    api.put(`/orders/${orderId}/instances/${instanceId}/status`, data),
  assignWorkerToInstance: (orderId, instanceId, data) =>
    api.put(`/orders/${orderId}/instances/${instanceId}/assign`, data),
  uploadLineImages: (orderId, lineId, formData) =>
    api.post(`/orders/${orderId}/lines/${lineId}/images`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    }),
  uploadLineAudio: (orderId, lineId, formData) =>
    api.post(`/orders/${orderId}/lines/${lineId}/audio`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    }),
  deleteLineAudio: (orderId, lineId, audioIndex) =>
    api.delete(`/orders/${orderId}/lines/${lineId}/audio/${audioIndex}`),
  updateLineAudioNote: (orderId, lineId, audioIndex, note) =>
    api.put(`/orders/${orderId}/lines/${lineId}/audio/${audioIndex}/note`, {note}),
  getHistory: id => api.get(`/orders/${id}/history`),
  getInstanceTasks: (orderId, instanceId) =>
    api.get(`/orders/${orderId}/instances/${instanceId}/tasks`),
  saveInstanceTasks: (orderId, instanceId, data) =>
    api.put(`/orders/${orderId}/instances/${instanceId}/tasks`, data),
  getPayments: orderId => api.get(`/orders/${orderId}/payments`),
  createPayment: (orderId, data) => api.post(`/orders/${orderId}/payments`, data),
  updateOrderDate: (id, data) => api.patch(`/orders/${id}/order-date`, data),
  applyDiscount: (orderId, data) => api.put(`/orders/${orderId}/discount`, data),
  removeDiscount: orderId => api.delete(`/orders/${orderId}/discount`),
  search: data => api.post('/orders/search', data),
};
